export const __ = (str) => str;
export const s__ = (str) => str.replace(/^(\w+\|)/u, '');
export const n__ = (singular, plural, num) => num === 1 ? singular : plural;
export const ns__ = (singular, plural, num) => s__(n__(singular, plural, num));
export const t = (str, _) => str;
//# sourceMappingURL=lib.js.map